import type {
  ChatsChannelBase,
  ChatsChannelSetting
} from '../../../constants/types';
import { ChatsChannelType } from '../../../constants/types';
import { getChatIcon } from '../../helpers';

export const getDiscordSettings = ({
  discordAccountId
}: Partial<ChatsChannelBase>) => {
  if (!discordAccountId) return null;

  const url = `https://discord.com/users/${discordAccountId}`;

  return {
    provider: ChatsChannelType.discord,
    link: { url },
    title: 'Discord',
    icon: getChatIcon(ChatsChannelType.discord)
  } as ChatsChannelSetting;
};
